import { render, staticRenderFns } from "./CommonSpeechEvaluating.vue?vue&type=template&id=4924521a&scoped=true"
import script from "./CommonSpeechEvaluating.vue?vue&type=script&lang=js"
export * from "./CommonSpeechEvaluating.vue?vue&type=script&lang=js"
import style0 from "./CommonSpeechEvaluating.vue?vue&type=style&index=0&id=4924521a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4924521a",
  null
  
)

export default component.exports